<!-- eslint-disable vue/attribute-hyphenation -->
<template>
    <v-col class="pt-0" cols="12" sm="12">
<!-- >>> Upper Tabs -->
        <v-row>
            <v-col class="pt-0" cols="12" sm="12">
                <v-tabs
                    v-if="editorMode==='create'"
                    v-model="data[leg].input_FlightTypeTab"
                    background-color="#f5f5f5"
                    tabindex="-1"
                    class="sdr-custom-tabs"
                    @change="onChange_TabChange">
                    <v-tab tabindex="-1" active-class="sdr-custom-tab-active">
                        Direct Flight
                    </v-tab>
                    <v-tab tabindex="-1" active-class="sdr-custom-tab-active">
                        VIA Flight
                    </v-tab>
                    <v-tab v-if="editorFlightLegMode !== 'rotation'" tabindex="-1" active-class="sdr-custom-tab-active">
                        TRIA Flight
                    </v-tab>
                </v-tabs>
            </v-col>
        </v-row>
        <!-- <<< Upper Tabs -->


        <!-- >>> Title -->
        <v-row>
            <v-col class="py-0" cols="12" sm="12">
                <h2 v-if="leg === 'firstLeg'" class="mb-8">
                    First Leg
                </h2>
                <h2 v-if="leg === 'secondLeg'" class="mb-8">
                    Second Leg
                </h2>
            </v-col>
        </v-row>
        <!-- <<< Title -->

        <v-tabs-items v-model="data[leg].input_FlightTypeTab">
            <!-- direct -->
            <v-tab-item eager>
                <sdr-step-3-routeconfig-directflight
                    :editorMode="editorMode"
                    :data="data"
                    :leg="leg"
                    :rules="rules"
                    :onChange_FlightNo="onChange_FlightNo"
                    :onChange_directFlight_AirportDeparture="onChange_directFlight_AirportDeparture"
                    :onChange_directFlight_AirportDestination="onChange_directFlight_AirportDestination"
                    :onChange_checkForOvernight="onChange_checkForOvernight"
                    :onChange_fillBlockTimes="onChange_fillBlockTimes"
                    :onChange_autoFillTurnaroundTime="onChange_autoFillTurnaroundTime"
                    :showDeleteCheckbox="showDeleteCheckbox"
                    :onChange_ActualTime="onChange_ActualTime"
                    :createMissingSlotString="createMissingSlotString"
                    :onChange_setSlotRequestStatus="onChange_setSlotRequestStatus" />
            </v-tab-item>
            <!-- direct -->

            <!-- via -->
            <v-tab-item eager>
                <sdr-step-3-routeconfig-viaflight
                    :editorMode="editorMode"
                    :data="data"
                    :leg="leg"
                    :rules="rules"
                    :onChange_FlightNo="onChange_FlightNo"
                    :onChange_viaFlight_AirportDeparture="onChange_viaFlight_AirportDeparture"
                    :onChange_viaFlight_AirportDestination="onChange_viaFlight_AirportDestination"
                    :onChange_checkForOvernight="onChange_checkForOvernight"
                    :onChange_fillBlockTimes="onChange_fillBlockTimes"
                    :onChange_autoFillTurnaroundTime="onChange_autoFillTurnaroundTime"
                    :onChange_ActualTime="onChange_ActualTime"
                    :createMissingSlotString="createMissingSlotString"
                    :showDeleteCheckbox="showDeleteCheckbox"
                    :onChange_setSlotRequestStatus="onChange_setSlotRequestStatus" />
            </v-tab-item>
            <!-- via -->

            <!-- tria -->
            <v-tab-item eager>
                <sdr-step-3-routeconfig-triaflight
                    :editorMode="editorMode"
                    :data="data"
                    :leg="leg"
                    :rules="rules"
                    :onChange_FlightNo="onChange_FlightNo"
                    :onChange_checkForOvernight="onChange_checkForOvernight"
                    :onChange_SetAtcCallSign="onChange_SetAtcCallSign"
                    :onChange_fillBlockTimes="onChange_fillBlockTimes"
                    :onChange_autoFillTurnaroundTime="onChange_autoFillTurnaroundTime"
                    :onChange_ActualTime="onChange_ActualTime"
                    :createMissingSlotString="createMissingSlotString"
                    :showDeleteCheckbox="showDeleteCheckbox"
                    :onChange_setSlotRequestStatus="onChange_setSlotRequestStatus" />
            </v-tab-item>
            <!-- tria -->
        </v-tabs-items>

        <!-- >>> Switches -->
        <div v-if="get_flights_OCCMode === true">
            <v-row class="input-row">
                <v-col class="py-0" cols="12" sm="12">
                    <h2 class="mb-8">
                    Checkin & Co
                    </h2>
                </v-col>

                <v-col class="pt-0" cols="12" sm="8">
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-switch
                                v-model="data[leg].input_Switch_CheckIn"
                                label="Keep CheckIn" />
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-switch
                                v-model="data[leg].input_Switch_CheckOut"
                                label="Keep CheckOut" />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>

        <!-- <<< Switches -->
    </v-col>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters } from 'vuex';
    import dayjs from 'dayjs';
    import Step3RouteConfig_DirectFlight from './Step3RouteConfig/Step3RouteConfig_DirectFlight.vue'; // Direct Flight Details
    import Step3RouteConfig_ViaFlight from './Step3RouteConfig/Step3RouteConfig_ViaFlight.vue'; // Tria Flight Details
    import Step3RouteConfig_TriaFlight from './Step3RouteConfig/Step3RouteConfig_TriaFlight.vue'; // Direct Flight Details

    import { CONF_AUTO_COMPLETION_ACTIVATED, CONF_AUTO_COMPLETION_MINUTES, CONF_SLOT_ALLOWED_DELAY } from '../../../../../../../config';


    export default {
        name: 'SdrStep3Routeconfig',

        /* >>> *************************************************************** / /* Components */
		components: {

            'sdr-step-3-routeconfig-directflight': Step3RouteConfig_DirectFlight,
            'sdr-step-3-routeconfig-viaflight': Step3RouteConfig_ViaFlight,
            'sdr-step-3-routeconfig-triaflight': Step3RouteConfig_TriaFlight

		}, // eo components{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Props */
        props: {

            editorMode: String, // 'update', 'create'
            editorFlightLegMode: String, // 'single', 'rotation'
            data: Object, // entire 'crud' Object
            leg: String, // "firstLeg", "secondLeg"
            rules: Object,
            onChange_TabChange: Function,
            showDeleteCheckbox: Boolean,
            sheetShown: Boolean,
            onChangeMarkToDelete_setDeleteInformations: Function

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([

                'get_flights_OCCMode',
                'get_Blocktimes'

            ])

        }, // eo computed{}
        /* <<< ****************************************************************/




        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created () {

            const me = this;


            me.$toc('>>> vviews/flights/flights/slotmanagement/components/core/flight/BottomSheet/Step3RouteConfig.vue >>> created');
            if (me.editorMode === 'combine') {

                const autoFillDepaturePoints = [
                    'input_AB_Time_Departure_Scheduled',
                    'input_BC_Time_Departure_Scheduled',
                    'input_CA_Time_Departure_Scheduled'
                ];

                for (let i = 0; i <= autoFillDepaturePoints.length; i++) {

                    if (!Vue.prototype.$isEmpty(me.data[me.leg][autoFillDepaturePoints[i]])) {
                        me.onChange_fillBlockTimes(autoFillDepaturePoints[i]);
                        break;
                    }
                }
            }

        }, // eo function created()
        /* <<< ****************************************************************/



        /* >>> ***************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onChange_FlightNo
            *
            * Desc: Increase the number in firstLegs FlightNumber for the
            * Desc: secondLegs FlightNumber.
            * Note: FlightNr Strcuture: [CHARS] [NUMBERS] [CHAR(S) - (optional)]
            *
            */
            onChange_FlightNo: function(val) {

                const me = this;
                let secondLegFlightNo = '',
                    splittedFlightNo = [],
                    tmp_flightNo;


                me.$toc('>>> vviews/flights/flights/slotmanagement/components/core/flight/BottomSheet/Step3RouteConfig.vue >>> onChange_FlightNo');
                if (val !== null && val.length > 0) {
                    if (me.leg === 'firstLeg') {
                        splittedFlightNo = val.match(/[a-z]+|\d+|[a-z]+/gi);
                        tmp_flightNo = splittedFlightNo.filter(Number);

                        secondLegFlightNo = splittedFlightNo.join('');

                        if (tmp_flightNo.length > 0) {
                            tmp_flightNo = tmp_flightNo[0];

                            secondLegFlightNo = secondLegFlightNo.replace(tmp_flightNo, parseInt(tmp_flightNo) + 1);
                        }

                        // TODO: ATC Sign should be in onChange_SetAtcCallSign
                        me.data.secondLeg.input_directFlight_FlightNo = secondLegFlightNo;
                        me.data.secondLeg.input_directFlight_AtcCallSign = Vue.prototype.$createATCCallSign(secondLegFlightNo);
                        me.data.secondLeg.input_viaFlight_FlightNo = secondLegFlightNo;
                        me.data.secondLeg.input_viaFlight_AtcCallSign = Vue.prototype.$createATCCallSign(secondLegFlightNo);

                        // Note: Special Case Tria Flight
                        // FlightNo for TRIA gets generated and set in DIRECT and VIA Mode (unwanted)
                        // TODO: Describe it understandable
                        if (me.data[me.leg].input_FlightTypeTab === 2) {

                            me.data.firstLeg.input_triaFlight_FlightNoVia = secondLegFlightNo;
                        }

                    }

                    me.onChange_SetAtcCallSign(val, secondLegFlightNo);
                }

            }, // eo function onChange_FlightNo()


            /*******************************************************************
            * onChange_SetAtcCallSign()
            *
            * Desc: Sets the ATC Call Sign based on FlightNo
            * Note:
            *
            */
            onChange_SetAtcCallSign: function(val, secondLegFlightNo) {

                const me = this;
                let ATCCallSign = Vue.prototype.$createATCCallSign(val);

                if (Vue.prototype.$isEmpty(ATCCallSign)) {
                    ATCCallSign = 'not available';
                }


                me.$toc('>>> vviews/flights/flights/slotmanagement/components/core/flight/BottomSheet/Step3RouteConfig.vue >>> onChange_SetAtcCallSign');
                // Sets the ATC Call Sign for Direct Flight
                if (me.data[me.leg].input_FlightTypeTab === 0) {
                    me.data[me.leg].input_directFlight_AtcCallSign = ATCCallSign;
                }

                // Sets the ATC Call Sign for Via Flight
                if (me.data[me.leg].input_FlightTypeTab === 1) {
                    me.data[me.leg].input_viaFlight_AtcCallSign = ATCCallSign;
                }

                // Sets the ATC Call Sign for Tria Flight
                // secondLegFlightNo is undefined if triaFlight_FlightNoVia is directly changed
                // if so, the triaFlight_AtcCallSign doesn't get changed
                if (me.data[me.leg].input_FlightTypeTab === 2) {
                    if (secondLegFlightNo !== undefined) {
                        me.data[me.leg].input_triaFlight_AtcCallSign = ATCCallSign;
                        me.data.firstLeg.input_triaFlight_AtcCallSignVia = !Vue.prototype.$isEmpty(Vue.prototype.$createATCCallSign(secondLegFlightNo)) ? Vue.prototype.$createATCCallSign(secondLegFlightNo) : 'not available';
                    } else {
                        me.data.firstLeg.input_triaFlight_AtcCallSignVia = ATCCallSign;
                    }
                }

            }, // eo function onChange_SetAtcCallSign()


            /*******************************************************************
            * onChange_directFlight_AirportDeparture()
            *
            * Desc:
            * Note:
            *
            */
            onChange_directFlight_AirportDeparture: function(val) {

                const me = this;


                me.$toc('>>> vviews/flights/flights/slotmanagement/components/core/flight/BottomSheet/Step3RouteConfig.vue >>> onChange_directFlight_AirportDeparture');
                if (me.leg === 'secondLeg') {
                    me.data.firstLeg.input_directFlight_AirportDestination = val;
                    me.data.firstLeg.input_viaFlight_AirportDestination = val;
                }

            }, // eo function onChange_directFlight_AirportDeparture()


            /*******************************************************************
            * onChange_directFlight_AirportDestination
            *
            * Desc:
            * Note:
            *
            */
            onChange_directFlight_AirportDestination: function(val) {

                const me = this;


                me.$toc('>>> vviews/flights/flights/slotmanagement/components/core/flight/BottomSheet/Step3RouteConfig.vue >>> onChange_directFlight_AirportDestination');
                if (me.leg === 'firstLeg') {
                    me.data.secondLeg.input_directFlight_AirportDeparture = val;
                    me.data.secondLeg.input_viaFlight_AirportDeparture = val;
                }

            }, // eo function onChange_directFlight_AirportDestination()


            /*******************************************************************
            * onChange_viaFlight_AirportDeparture
            *
            * Desc:
            * Note:
            *
            */
            onChange_viaFlight_AirportDeparture: function(val) {

                const me = this;


                me.$toc('>>> vviews/flights/flights/slotmanagement/components/core/flight/BottomSheet/Step3RouteConfig.vue >>> onChange_viaFlight_AirportDeparture');
                if (me.leg === 'secondLeg') {
                    me.data.firstLeg.input_directFlight_AirportDestination = val;
                    me.data.firstLeg.input_viaFlight_AirportDestination = val;
                }

            }, // eo function onChange_viaFlight_AirportDeparture()


            /*******************************************************************
            * onChange_viaFlight_AirportDestination
            *
            * Desc:
            * Note:
            *
            */
            onChange_viaFlight_AirportDestination: function(val) {

                const me = this;


                me.$toc('>>> vviews/flights/flights/slotmanagement/components/core/flight/BottomSheet/Step3RouteConfig.vue >>> onChange_viaFlight_AirportDestination');
                if (me.leg === 'firstLeg') {
                    me.data.secondLeg.input_directFlight_AirportDeparture = val;
                    me.data.secondLeg.input_viaFlight_AirportDeparture = val;
                }

            }, // eo function onChange_viaFlight_AirportDestination()


            /*******************************************************************
            * onChange_checkForOvernight{}
            *
            * Desc:
            * Note:
            *
            */
            onChange_checkForOvernight: function(inputName) {

                const me = this;
                let tmp_overnight = false,
                    [AB_hour, AB_min] = [];


                me.$toc('>>> vviews/flights/flights/slotmanagement/components/core/flight/BottomSheet/Step3RouteConfig.vue >>> onChange_checkForOvernight');
                /***************************************************************
                * getGlobalOvernight{}
                *
                */
                const getGlobalOvernight = (compare) => {
                    if (!me.get_flights_OCCMode && Vue.prototype.$isEmpty(me.data[me.leg].input_AB_Time_Departure_Scheduled)) {
                        return;
                    }
                    if (me.get_flights_OCCMode && Vue.prototype.$isEmpty(me.data[me.leg].input_AB_Time_Departure_Actual)) {
                        return;
                    }

                    if (!me.get_flights_OCCMode) {
                        [AB_hour, AB_min] = me.data[me.leg].input_AB_Time_Departure_Scheduled.split(':');
                    } else {
                        [AB_hour, AB_min] = me.data[me.leg].input_AB_Time_Departure_Actual.split(':');
                    }

                    let overnight = false;


                    if (Vue.prototype.$isEmpty(compare) === false) {
                        const [compareTime_hour, compareTime_min] = compare.split(':');
                        if (String(AB_hour) + String(AB_min) >= String(compareTime_hour) + String(compareTime_min)) {
                            overnight = true;
                        }
                        if (String(AB_hour) + String(AB_min) === '0000' && String(compareTime_hour) + String(compareTime_min) === '0000') {
                            overnight = true;
                        }
                    }

                    return overnight;
                };


                /***************************************************************
                * getLegOvernight{}
                *
                */
                const getLegOvernight = (leg_Departure, leg_Arrival) => {

                    let leg_Departure_hour,
                        leg_Departure_min,
                        leg_Arrival_hour,
                        leg_Arrival_min,
                        overnight = false;


                    if (Vue.prototype.$isEmpty(leg_Departure) === false && Vue.prototype.$isEmpty(leg_Arrival) === false) {

                        [leg_Departure_hour, leg_Departure_min] = leg_Departure.split(':');
                        [leg_Arrival_hour, leg_Arrival_min] = leg_Arrival.split(':');
                        if (String(leg_Departure_hour) + String(leg_Departure_min) >= String(leg_Arrival_hour) + String(leg_Arrival_min)) {
                            overnight = true;
                        }
                        if (String(leg_Departure_hour) + String(leg_Departure_min) === '0000' && String(leg_Arrival_hour) + String(leg_Arrival_min) === '0000') {
                            overnight = true;
                        }

                    }

                    return overnight;

                };


                setTimeout(() => {
                    if (Vue.prototype.$isEmpty(me.data[me.leg].input_AB_Time_Departure_Scheduled) === false) {

                        // ----- AB
                        if (me.get_flights_OCCMode) {
                            tmp_overnight = getGlobalOvernight(me.data[me.leg].input_AB_Time_Arrival_Actual);
                        } else {
                            tmp_overnight = getGlobalOvernight(me.data[me.leg].input_AB_Time_Arrival_Scheduled);
                        }

                        // ----- BC
                        if (tmp_overnight !== true) {
                            tmp_overnight = getLegOvernight(me.data[me.leg].input_BC_Time_Departure_Scheduled, me.data[me.leg].input_BC_Time_Arrival_Scheduled);
                        }

                        if (tmp_overnight !== true) {
                            tmp_overnight = getGlobalOvernight(me.data[me.leg].input_BC_Time_Arrival_Scheduled);
                        }

                        // ----- CA
                        if (tmp_overnight !== true) {
                            tmp_overnight = getLegOvernight(me.data[me.leg].input_CA_Time_Departure_Scheduled, me.data[me.leg].input_CA_Time_Arrival_Scheduled);
                        }

                        if (tmp_overnight !== true) {
                            tmp_overnight = getGlobalOvernight(me.data[me.leg].input_CA_Time_Arrival_Scheduled);
                        }

                        if (me.editorFlightLegMode === 'rotation') {

                            if (tmp_overnight !== true) {

                                me.data.secondLeg.input_nextDay = getLegOvernight(me.data.firstLeg.input_AB_Time_Arrival_Scheduled, me.data.secondLeg.input_AB_Time_Departure_Scheduled);
                            }

                        }

                    }

                    me.data[me.leg].input_overnight = tmp_overnight;
                }, 100);

            }, // eo function onChange_checkForOvernight()


            /*******************************************************************
            * onChange_autoFillTurnaroundTime{}
            *
            * Desc: Auto fills Depature Time based on Arrival Time + Turnaround time (50min)
            * Note: Route Pairs Array offers connection between inputs to identify the input to be autofilled
            *
            */
            onChange_autoFillTurnaroundTime: function(inputName, autoSelectedLeg) {

                const me = this,
                    routeTypeOptions = ['direct', 'via', 'tria'],
                    routePairs = [
                        {
                            legMode: 'single',
                            type: 'via',
                            arr: 'input_AB_Time_Arrival_Scheduled',
                            dep: 'input_BC_Time_Departure_Scheduled',
                            leg: 'firstLeg'
                        },
                        {
                            legMode: 'single',
                            type: 'tria',
                            arr: 'input_AB_Time_Arrival_Scheduled',
                            dep: 'input_BC_Time_Departure_Scheduled',
                            leg: 'firstLeg'
                        },
                        {
                            legMode: 'single',
                            type: 'tria',
                            arr: 'input_BC_Time_Arrival_Scheduled',
                            dep: 'input_CA_Time_Departure_Scheduled',
                            leg: 'firstLeg'
                        },
                        {
                            legMode: 'rotation',
                            type: 'direct',
                            arr: 'input_AB_Time_Arrival_Scheduled',
                            dep: 'input_AB_Time_Departure_Scheduled',
                            leg: 'secondLeg'
                        },
                        {
                            legMode: 'rotation',
                            type: 'direct',
                            arr: 'input_BC_Time_Arrival_Scheduled',
                            dep: 'input_AB_Time_Departure_Scheduled',
                            leg: 'secondLeg'
                        },

                        {
                            legMode: 'rotation',
                            type: 'via',
                            arr: 'input_AB_Time_Arrival_Scheduled',
                            dep: 'input_BC_Time_Departure_Scheduled',
                            leg: autoSelectedLeg
                        },
                        {
                            legMode: 'rotation',
                            type: 'via',
                            arr: 'input_BC_Time_Arrival_Scheduled',
                            dep: 'input_AB_Time_Departure_Scheduled',
                            leg: 'secondLeg'
                        }

                    ];
                let [h, m] = [],
                    routeType = '',
                    currentRoutePair = {};


                me.$toc('>>> vviews/flights/flights/slotmanagement/components/core/flight/BottomSheet/Step3RouteConfig.vue >>> onChange_autoFillTurnaroundTime');
                routeType = routeTypeOptions[me.data[autoSelectedLeg].input_FlightTypeTab];

                if (CONF_AUTO_COMPLETION_ACTIVATED === false) {
                    return;
                }
                // airport field empty? return!
                if (Vue.prototype.$isEmpty(me.data[me.leg][inputName])) {
                    return;
                }
                // last input field in form, so we don't need to autofill something
                if (autoSelectedLeg === 'secondLeg' && routeType === 'direct' && inputName === 'input_AB_Time_Arrival_Scheduled') {
                    return;
                }
                // last input field in form, so we don't need to autofill something
                if (autoSelectedLeg === 'secondLeg' && routeType === 'via' && inputName === 'input_BC_Time_Arrival_Scheduled') {
                    return;
                }
                // searches for the route pair to identify which field has to be autofilled
                currentRoutePair = routePairs.find((routePair) => routePair.type === routeType && routePair.arr === inputName && routePair.legMode === me.editorFlightLegMode);
                if (Vue.prototype.$isEmpty(currentRoutePair)) {
                    return;
                }

                // set departure time + 50min into identified input field
                [h, m] = me.data[autoSelectedLeg][currentRoutePair.arr].split(':');
                me.data[currentRoutePair.leg][currentRoutePair.dep] = dayjs().hour(h).minute(m).add(CONF_AUTO_COMPLETION_MINUTES, 'minutes').format('HH:mm');

                // set blocktime based on turnaround time
                me.onChange_fillBlockTimes(currentRoutePair.dep, currentRoutePair.leg);

            }, // eo function onChange_autoFillTurnaroundTime()


            /*******************************************************************
            * onChange_fillBlockTimes{}
            *
            * Desc: Autofills the Block Time based on Depature Time + saved Blocktime (Blocktimes Module)
            * Note: Route Pairs Array offers connection between inputs to identify the input to be autofilled
            *
            */
            onChange_fillBlockTimes: function(inputName, autoSelectedLeg = this.leg) {

                const me = this,
                    currentLeg = autoSelectedLeg,
                    routeType = ['direct', 'via', 'tria'],
                    routePairs = [
                        {
                            dep: 'input_AB_Time_Departure_Scheduled',
                            arr: 'input_AB_Time_Arrival_Scheduled',
                            direct: {
                                airportDep: 'input_directFlight_AirportDeparture',
                                airportArr: 'input_directFlight_AirportDestination'
                            },
                            via: {
                                airportDep: 'input_viaFlight_AirportDeparture',
                                airportArr: 'input_viaFlight_AirportVia'
                            },
                            tria: {
                                airportDep: 'input_triaFlight_AirportDestinationDeparture',
                                airportArr: 'input_triaFlight_AirportFirstVia'
                            }
                        },
                        {
                            dep: 'input_BC_Time_Departure_Scheduled',
                            arr: 'input_BC_Time_Arrival_Scheduled',
                            via: {
                                airportDep: 'input_viaFlight_AirportVia',
                                airportArr: 'input_viaFlight_AirportDestination'
                            },
                            tria: {
                                airportDep: 'input_triaFlight_AirportFirstVia',
                                airportArr: 'input_triaFlight_AirportSecondVia'
                            }

                        },
                        {
                            dep: 'input_CA_Time_Departure_Scheduled',
                            arr: 'input_CA_Time_Arrival_Scheduled',
                            tria: {
                                airportDep: 'input_triaFlight_AirportSecondVia',
                                airportArr: 'input_triaFlight_AirportDestinationDeparture'
                            }
                        }
                    ];
                let [h, m] = [],
                    [hBlocktime, mBlocktime] = [],
                    foundBlocktime = '',
                    departureAirport = {},
                    destinationAirport = {},
                    currentRoutePair = {};


                me.$toc('>>> vviews/flights/flights/slotmanagement/components/core/flight/BottomSheet/Step3RouteConfig.vue >>> onChange_fillBlockTimes');
                currentRoutePair = routePairs.find((routePair) => routePair.dep === inputName);
                if (Vue.prototype.$isEmpty(currentRoutePair) || Vue.prototype.$isEmpty(me.data[currentLeg][currentRoutePair.dep])) {
                    return;
                }

                [h, m] = me.data[currentLeg][currentRoutePair.dep].split(':');
                departureAirport = me.data[currentLeg][currentRoutePair[routeType[me.data[currentLeg].input_FlightTypeTab]].airportDep];
                destinationAirport = me.data[currentLeg][currentRoutePair[routeType[me.data[currentLeg].input_FlightTypeTab]].airportArr];




                if (Vue.prototype.$isEmpty(departureAirport) || Vue.prototype.$isEmpty(destinationAirport)) { // CAR: changed && to ||, if only dep/des airport is set, you can not calcualte block times
                    return;
                }

                foundBlocktime = me.get_Blocktimes.find((blocktime) =>
                    blocktime.aptFromCode === departureAirport.aptCode &&
                    blocktime.aptToCode === destinationAirport.aptCode
                );

                if (Vue.prototype.$isEmpty(foundBlocktime)) {
                    me.data[currentLeg][currentRoutePair.arr] = null; // reset? #183 (SINGLE/DIRECT)
                    return;
                }

                [hBlocktime, mBlocktime] = foundBlocktime.blockTime.split(':');
                me.data[currentLeg][currentRoutePair.arr] = dayjs().hour(h).minute(m).add(hBlocktime, 'hours').add(mBlocktime, 'minutes').format('HH:mm');

                // Filter to autofill chain (respectively the last input field in form, so that no autfill is needed)
                if (this.editorFlightLegMode === 'rotation') {

                    if (routeType[me.data[currentLeg].input_FlightTypeTab] === 'direct') {

                        if (currentLeg === 'secondLeg' && inputName === 'input_AB_Time_Departure_Scheduled') {
                            return;
                        }

                    }

                    if (routeType[me.data[currentLeg].input_FlightTypeTab] === 'via') {

                        if (currentLeg === 'secondLeg' && inputName === 'input_BC_Time_Departure_Scheduled') {
                            return;
                        }

                    }
                }

                me.onChange_autoFillTurnaroundTime(currentRoutePair.arr, currentLeg);

            }, // eo function onChange_fillBlockTimes()


            /*******************************************************************
            * onChange_fillBlockTimes{}
            *
            * Desc: After changing the actual time, toggle the keepCrewCI switch.
            * Note:
            *
            */
            onChange_ActualTime: function(type) {

                const me = this;


                me.$toc('>>> vviews/flights/flights/slotmanagement/components/core/flight/BottomSheet/Step3RouteConfig.vue >>> onChange_ActualTime');
                if (me.get_flights_OCCMode === true) {
                    me.data.firstLeg.input_Switch_CheckIn = true;
                }

            }, // eo function onChange_ActualTime()


            /*******************************************************************
            * createMissingSlotString{}
            *
            * Desc: Gets triggered everytime an input is done
            * Note:
            *
            */
            createMissingSlotString: function(airport, slot, scheduled) {

                const me = this;
                let warningMsg = '';


                me.$toc('>>> vviews/flights/flights/slotmanagement/components/core/flight/BottomSheet/Step3RouteConfig.vue >>> createMissingSlotString');
                if (!Vue.prototype.$isEmpty(me.data[me.leg][airport]) && me.data[me.leg][airport].coordinated) {

                    if (Vue.prototype.$isEmpty(me.data[me.leg][slot])) {
                        warningMsg = '<div class=\'red--text text--lighten-1\'>Slot is missing!</div>';
                    }
                    if (!Vue.prototype.$isEmpty(me.data[me.leg][scheduled]) && !Vue.prototype.$isEmpty(me.data[me.leg][slot])) {
                        const [schedule_HH, schedule_mm] = me.data[me.leg][scheduled].split(':');
                        const [slot_HH, slot_mm] = me.data[me.leg][slot].split(':');
                        const slotScheduleTimeDiff = Math.abs(dayjs().hour(schedule_HH).minute(schedule_mm).diff(dayjs().hour(slot_HH).minute(slot_mm), 'minute'));

                        if (slotScheduleTimeDiff > CONF_SLOT_ALLOWED_DELAY) {
                            warningMsg = '<div class=\'warning--text\'>Slot has to be Scheduled Time</div>';
                        }
                    }
                }


                return warningMsg;

            }, // eo function createMissingSlotString{}

            /*******************************************************************
            * onChange_highlightField{}
            *
            * Desc: Highlights an input field for 1500ms.
            * Note: "HACK": when input_weekly_NumberOfWeeks change in the above line the cssClassList
            * Note: will change, so if we want to change the cssClassList too, we need to wait
            *
            * @param {string} fieldName (ref name of input field)
            *
            */
            onChange_highlightField: function(fieldRef) {

                const me = this;


                me.$toc('>>> views/flights/flights/slotmanagement/components/core/flight/BottomSheet/Step3RouteConfig.vue >>> onChange_highlightField');

                if (fieldRef && fieldRef.$el) {
                    setTimeout(function() {
                        fieldRef.$el.classList.add('input-glow');
                    }, 100);

                    setTimeout(function() {
                        fieldRef.$el.classList.remove('input-glow');
                    }, 1600);
                }

            }, // eo function onChange_highlightField()

            /*******************************************************************
            * onChange_setSlotRequestStatus{}
            *
            * Desc:
            * Note:
            *
            * @param {string} fieldName (ref name of input field)
            *
            */
            onChange_setSlotRequestStatus: function (inputField, fieldRef) {

                const me = this;
                me.$toc('>>> vviews/flights/flights/slotmanagement/components/core/flight/BottomSheet/Step3RouteConfig.vue >>> createMissingSlotString');
                me.data[me.leg][inputField] = 'confirmed';
                me.onChange_highlightField(fieldRef);

            } // eo function onChange_setSlotRequestStatus()

        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>
